import axios from '@axios'
import { getOrderCount } from '@/utils/indexDB/index.js'

export default {
    namespaced: true,
    state: {
        products: [],
        orderLines: 0,
    },
    getters: {
        isProductsFetched: (state) => state.products.length > 0,
        getProducts: (state) => state.products,
        // getOrderLines: (state) => state.orderLines == 0 ? 0 : parseInt(state.orderLines) - 1,
        getOrderLines: (state) => parseInt(state.orderLines),
        getProductByNo: (state) => (id) => {
            // Find the product with the specified id
            return state.products.find((product) => product.No === id);
        },
    },
    mutations: {
        UPDATE_PRODUCTS_LIST(state, payload) {
            state.products = payload
        },
        UPDATE_ORDER_LINES(state, payload) {
            state.orderLines = payload
        },
    },
    actions: {
        INITIALIZE_PRODUCTS_LIST({ commit }) {
            console.log("INITIALIZE_PRODUCTS_LIST")
            return new Promise((resolve, reject) => {
                axios.get('navendpoints/getProducts').then(response => {
                    commit('UPDATE_PRODUCTS_LIST', response.data.value)
                    resolve(response)
                }).catch(error => {
                    console.log(error);
                    console.log(error.response);
                    reject(error)
                })
            })
        },
        GET_INVENTORY(context, payload) {
            // console.log(commit);
            return new Promise((resolve, reject) => {
                axios.get('navendpoints/getInventory', { params: { code: payload.code, qte: payload.qte } }).then(response => {
                    // console.log(response);
                    let respStruct = {
                        title: "",
                        icon: "",
                        text: "",
                        variant: "",
                        promotion: "",
                    };
                    if (response.data.Quotas_Item_Exist) {
                        // if (payload.qte <= parseInt(response.data.Quotas_Item_by_Customer) && payload.qte <= parseInt(response.data.Quantity_available)) {
                        if (payload.qte <= parseInt(response.data.Quantity_available)) {
                            respStruct.title = "Quantité réservée";
                            respStruct.icon = "CheckIcon";
                            respStruct.variant = "success";

                        } else {
                            respStruct.title = "Indisponible en stock !";
                            respStruct.icon = "XOctagonIcon";
                            respStruct.text = "Aucun stock disponible pour l’article  «" + response.data.Description + "»";
                            respStruct.variant = "danger";
                        }
                        // respStruct.title = "Article en répartition !";
                        // respStruct.icon = 'CodesandboxIcon';
                        // respStruct.text = "L’article  «" + response.data.Description + "» est en répartition.";
                        // respStruct.variant = 'warning';
                    } else {
                        if (parseInt(response.data.Quantity_available) <= 0) {
                            respStruct.title = "Indisponible en stock !";
                            respStruct.icon = "XOctagonIcon";
                            respStruct.text = "Aucun stock disponible pour l’article  «" + response.data.Description + "»";
                            respStruct.variant = "danger";
                        } else if (payload.qte > parseInt(response.data.Quantity_available)) {
                            respStruct.title = "Stock insuffisant !";
                            respStruct.icon = "AlertOctagonIcon";
                            respStruct.text = "Impossible de satisfaire la quantité demandée pour l’article «" + response.data.Description + "»";
                            respStruct.variant = "danger";
                        } else if (response.data.Promotion_Inventory > 0 && response.data.Promotion_Exist) {
                            if (parseInt(response.data.Sales_threshold) > payload.qte) {
                                respStruct.title = "Promotion !";
                                respStruct.icon = "GiftIcon";
                                respStruct.text = "Une promotion disponible pour l’article «" +
                                    payload.qte +
                                    "», changer la quantité pour pouvoir bénéficier de la promotion : " +
                                    response.data.Sales_threshold +
                                    " -> " +
                                    response.data.Free_Sales_Qty;
                                respStruct.variant = "info";
                                respStruct.promotion = response.data.Sales_threshold + " -> " + response.data.Free_Sales_Qty;
                            } else {
                                var unitesGratuits = (payload.qte / response.data.Sales_threshold) * response.data.Free_Sales_Qty;
                                if (unitesGratuits > response.data.Promotion_Inventory) {
                                    unitesGratuits = response.data.Promotion_Inventory;
                                }
                                respStruct.title = "Promotion !";
                                respStruct.icon = "GiftIcon";
                                respStruct.text = "Vous avez bénéficié de " + Math.floor(unitesGratuits) +
                                    " Unitée(s) gratuite(s) «" + response.data.Sales_threshold +
                                    " -> " + response.data.Free_Sales_Qty + "»";
                                respStruct.variant = "info";
                                respStruct.promotion = "+" + Math.floor(unitesGratuits);
                            }
                        } else {
                            respStruct.title = "Quantité réservée";
                            respStruct.icon = "CheckIcon";
                            // respStruct.text = "Impossible de satisfaire la quantité demandée pour l’article  «" + response.data.Description + "».";
                            respStruct.variant = "success";
                        }
                    }
                    resolve(respStruct)
                })
                    .catch(error => {
                        console.log(error);
                        console.log(error.response);
                        reject(error)
                    })
            })
        },
        COUNT_ORDER_LINES({ commit }) {
            getOrderCount().then(nb => {
                commit('UPDATE_ORDER_LINES', nb.result);
            })
        },
        UPDATE_ORDER_LINES({ commit }, payload) {
            commit('UPDATE_ORDER_LINES', payload);
        },
    },
}
